// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.team-edit-view .content[data-v-1750ec7b] {
	height: 100%;
	position: relative;
	display: flex;
	flex-direction: column;
}
.team-edit-view .content .ag-grid-vue[data-v-1750ec7b] {
	flex: 1
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
